import 'dom4'
import 'svgxuse'
import domready from 'domready'
import SubscribePopup from '../subscribe-popup'
import GlobalHeader from '../global-header'
import ScrollBtn from '../scroll-btn'
import Accordion from '../accordion'
import PageHero from '../section/page-hero'
import Slider from '../slider'
import InView from '../in-view'
import TerrenSelect from '../section/terren-select'

const touchDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)

domready(() => {

  if (touchDevice) {
    document.body.classList.add('touch')
  }

  document.queryAll('.in-view').forEach(element => {
    new InView({
      element
    })
  })

  document.queryAll('[data-component="scroll-btn"]').forEach(element => {
    new ScrollBtn({
      element
    })
  })

  document.queryAll('[data-component="subscribe-popup"]').forEach(element => {
    new SubscribePopup({
      element
    })
  })



  document.queryAll('[data-component="global-header"]').forEach(element => {
    new GlobalHeader({
      element
    })
  })

  document.queryAll('[data-component="accordion"]').forEach(element => {
    new Accordion({
      element
    })
  })

  document.queryAll('[data-component="page-hero"]').forEach(element => {
    new PageHero({
      element
    })
  })

  document.queryAll('[data-component="slider"]').forEach(element => {
    new Slider({
      element
    })
  })

  document.queryAll('[data-component="terren-select"]').forEach(element => {
    new TerrenSelect({
      element
    })
  })

})



// WEBPACK FOOTER //
// ./components/app/index.js